(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* Header */
  const header = $(".gcs-header");
  if (header) {
    const onHero = header.dataset.onHero === "true" || !!document.querySelector(".gcs-hero");
    const apply = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const light = onHero && y < 48 && !header.classList.contains("is-open");
      header.classList.toggle("is-light", light);
      header.classList.toggle("is-scrolled", !light);
    };
    apply();
    window.addEventListener("scroll", apply, { passive: true });
    document.addEventListener("scroll", apply, { passive: true, capture: true });
    const toggle = $(".gcs-menu-toggle");
    if (toggle) {
      toggle.addEventListener("click", () => {
        header.classList.toggle("is-open");
        apply();
      });
    }
  }

  /* Hero film */
  const hero = $(".gcs-hero");
  if (hero) {
    const video = $("video", hero);
    const desktop = hero.dataset.desktop || "";
    const mobile = hero.dataset.mobile || desktop;
    const playBtn = $("[data-hero-play]", hero);
    const muteBtn = $("[data-hero-mute]", hero);
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const portrait = () => window.innerWidth < 900 || window.innerHeight > window.innerWidth;
    const applySrc = () => {
      if (!video) return;
      const next = portrait() && mobile ? mobile : desktop;
      if (!next) return;
      const key = next.split("?")[0].slice(-24);
      const cur = video.currentSrc || video.getAttribute("src") || "";
      if (cur.indexOf(key) !== -1) return;
      const wasMuted = video.muted;
      video.src = next;
      video.muted = wasMuted;
      video.load();
      if (!reduce) {
        video.play().then(() => setPlayIcon()).catch(() => {});
      }
    };

    const setPlayIcon = () => {
      if (!playBtn || !video) return;
      const paused = video.paused;
      playBtn.classList.toggle("is-paused", paused);
      playBtn.setAttribute("aria-label", paused ? "Play film" : "Pause film");
      const pauseIcon = $("[data-icon-pause]", playBtn);
      const playIcon = $("[data-icon-play]", playBtn);
      if (pauseIcon) pauseIcon.hidden = paused;
      if (playIcon) playIcon.hidden = !paused;
    };

    const setMuteIcon = () => {
      if (!muteBtn || !video) return;
      muteBtn.dataset.muted = String(video.muted);
      muteBtn.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
      const off = $("[data-icon-off]", muteBtn);
      const on = $("[data-icon-on]", muteBtn);
      if (off) off.hidden = !video.muted;
      if (on) on.hidden = video.muted;
    };

    const start = async () => {
      if (!video || reduce) return;
      applySrc();
      video.muted = true;
      setMuteIcon();
      try { await video.play(); } catch (_) {}
      setPlayIcon();
    };

    applySrc();
    start();
    window.addEventListener("resize", () => { applySrc(); });
    playBtn && playBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (!video) return;
      if (video.paused) video.play(); else video.pause();
      setPlayIcon();
    });
    muteBtn && muteBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (!video) return;
      video.muted = !video.muted;
      setMuteIcon();
      if (!video.muted) video.play();
      setPlayIcon();
    });
    video && video.addEventListener("play", setPlayIcon);
    video && video.addEventListener("pause", setPlayIcon);
  }

  /* Product gallery */
  $$("[data-product-gallery]").forEach((g) => {
    const stage = $("[data-stage]", g);
    $$("[data-thumb]", g).forEach((btn) => {
      btn.addEventListener("click", () => {
        $$("[data-thumb]", g).forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        if (stage) stage.src = btn.dataset.src;
      });
    });
  });

  /* Cart */
  const overlay = $(".gcs-cart-overlay");
  const drawer = $(".gcs-cart");
  const countEls = $$("[data-cart-count]");
  const itemsEl = $("[data-cart-items]");
  const money = (cents) => {
    try {
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify?.currency?.active || "USD" });
    } catch {
      return "$" + (cents / 100).toFixed(2);
    }
  };

  function openCart() { document.body.classList.add("cart-open"); }
  function closeCart() { document.body.classList.remove("cart-open"); }
  overlay && overlay.addEventListener("click", closeCart);
  $("[data-cart-close]") && $("[data-cart-close]").addEventListener("click", closeCart);
  $$("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); refreshCart().then(openCart); }));

  function renderCart(cart) {
    countEls.forEach((el) => {
      const n = cart.item_count || 0;
      el.textContent = n;
      el.hidden = n === 0;
    });
    if (!itemsEl) return;
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="gcs-cart-empty">The bag is empty.</p>';
      const sub = $("[data-cart-subtotal]");
      if (sub) sub.textContent = money(0);
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => {
      const props = Object.entries(item.properties || {})
        .filter(([k, v]) => v && !String(k).startsWith("_"))
        .map(([k, v]) => `${k}: ${v}`)
        .join("<br>");
      return `<article class="gcs-cart-row">
        <img src="${item.image ? item.image.replace(/(\.[^.]+)$/, "_140x$1") : ""}" alt="">
        <div>
          <h3>${item.product_title}</h3>
          <p class="gcs-cart-props">${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}${props ? "<br>" + props : ""}</p>
          <p class="gcs-cart-props">${item.quantity} × ${money(item.final_line_price / item.quantity)}</p>
        </div>
        <button type="button" data-remove="${item.key}" aria-label="Remove">×</button>
      </article>`;
    }).join("");
    const sub = $("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
    $$("[data-remove]", itemsEl).forEach((btn) => {
      btn.addEventListener("click", async () => {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: btn.dataset.remove, quantity: 0 }),
        });
        refreshCart();
      });
    });
  }

  async function refreshCart() {
    const cart = await fetch("/cart.js").then((r) => r.json());
    renderCart(cart);
    return cart;
  }
  refreshCart();

  $$("form[action='/cart/add']").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      if (form.dataset.native === "true") return;
      e.preventDefault();
      const fd = new FormData(form);
      const res = await fetch("/cart/add.js", { method: "POST", body: fd });
      if (!res.ok) {
        form.submit();
        return;
      }
      await refreshCart();
      openCart();
    });
  });

  /* Wholesale portal */
  const root = $("[data-wholesale-root]");
  const gate = $("[data-wholesale-gate]");
  const book = $("#WholesaleBook");
  const inquiry = $("#WholesaleInquiry");
  if (root && gate) {
    const expected = ((root.dataset.code || "GCS-TRADE").trim().toUpperCase() || "GCS-TRADE").replace(/[^A-Z0-9]/g, "");
    const show = (which) => {
      gate.classList.toggle("is-hidden", which !== "gate");
      if (book) book.classList.toggle("is-open", which === "book");
      if (inquiry) inquiry.classList.toggle("is-open", which === "inquiry");
    };
    let storedOk = false;
    try { storedOk = sessionStorage.getItem("gcs-wholesale-ok") === "1"; } catch (e) {}
    if ($("[data-wholesale-done]") || storedOk) show("book");
    else if ($("[data-inquiry-done]")) show("inquiry");

    $("[data-show-inquiry]") && $("[data-show-inquiry]").addEventListener("click", () => show("inquiry"));
    $("[data-show-gate]") && $("[data-show-gate]").addEventListener("click", () => show("gate"));

    const unlock = $("[data-wholesale-unlock]");
    const tryUnlock = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      const typed = ((unlock && unlock.querySelector("input[name=code]")) || {}).value || "";
      const clean = String(typed).trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
      if (clean && clean === expected) {
        try { sessionStorage.setItem("gcs-wholesale-ok", "1"); } catch (err) {}
        show("book");
        return true;
      }
      const err = $("[data-wholesale-error]");
      if (err) err.hidden = false;
      return false;
    };
    if (unlock) {
      unlock.addEventListener("submit", tryUnlock);
      const codeInput = unlock.querySelector("input[name=code]");
      codeInput && codeInput.addEventListener("keydown", (e) => {
        if (e.key === "Enter") tryUnlock(e);
      });
      const unlockBtn = unlock.querySelector("button");
      unlockBtn && unlockBtn.addEventListener("click", tryUnlock);
    }

    const norm = (s) => String(s || "").trim().toLowerCase().replace(/\s+/g, " ");
    let accounts = [];
    try { accounts = JSON.parse(($("[data-wholesale-accounts]") || {}).textContent || "[]") || []; } catch (e) { accounts = []; }
    try { accounts = accounts.concat(JSON.parse(localStorage.getItem("gcs-wholesale-accounts") || "[]")); } catch (e) {}
    const listEl = $("#gcs-stores");
    const names = [];
    accounts.forEach((a) => {
      if (a && a.store && names.indexOf(a.store) < 0) {
        names.push(a.store);
        if (listEl) {
          const opt = document.createElement("option");
          opt.value = a.store;
          listEl.appendChild(opt);
        }
      }
    });
    const persistAccount = (acc) => {
      if (!acc || !acc.store || !acc.email) return;
      try {
        const prev = JSON.parse(localStorage.getItem("gcs-wholesale-accounts") || "[]").filter(function (a) {
          return norm(a.store) !== norm(acc.store);
        });
        localStorage.setItem("gcs-wholesale-accounts", JSON.stringify([acc].concat(prev)));
      } catch (e) {}
    };

    if (inquiry) {
      inquiry.addEventListener("submit", () => {
        const body = $("[data-inquiry-body]", inquiry);
        if (!body) return;
        const val = (name) => (inquiry.querySelector('[name="' + name + '"]') || {}).value || "";
        body.value = [
          "WHOLESALE INQUIRY",
          "Name: " + val("contact[name]"),
          "Email: " + val("contact[email]"),
          "Phone: " + val("contact[phone]"),
          "Business: " + val("contact[business]"),
          "Web / IG: " + val("contact[web]"),
          "City: " + val("contact[city]"),
          "Type: " + val("contact[account_type]"),
          "",
          "Looking for:",
          val("contact[looking]"),
        ].join("\n");
        persistAccount({
          store: val("contact[business]"),
          name: val("contact[name]"),
          email: val("contact[email]"),
          phone: val("contact[phone]"),
          ship: "",
          city: val("contact[city]"),
          region: "",
          zip: "",
        });
      });
    }

    let crewAssets = {};
    try { crewAssets = JSON.parse(($("[data-crew-assets]") || {}).textContent || "{}"); } catch (e) { crewAssets = {}; }
    try {
      const navySrc = crewAssets.pigment && crewAssets.pigment.truenavy;
      if (navySrc) {
        const warm = new Image();
        warm.decoding = "async";
        warm.src = navySrc;
      }
      if (document.fonts && document.fonts.load) {
        document.fonts.load("68px Hansief");
      }
    } catch (e) {}
    const list = $("[data-line-list]");
    const tpl = $("#gcs-line-tpl");
    const styleLabels = { classic: "Classic Crew", pigment: "Pigment Dyed Crew" };
    const fontLabels = { hansief: "BLOCK", kitten: "Script" };
    const bindCard = (card) => {
      const img = $("[data-crew-img]", card);
      const letters = $("[data-crew-letters]", card);
      const topInput = $("[data-f='lettering-top']", card);
      const botInput = $("[data-f='lettering-bottom']", card);
      const colorName = $("[data-color-name]", card);
      const currentStyle = () => card.getAttribute("data-style") || "pigment";
      const currentFont = () => card.getAttribute("data-font") || "hansief";
      const arcGroup = $("[data-arc-group]", card);
      const botText = $("[data-bot-text]", card);
      const svgNS = "http://www.w3.org/2000/svg";

      const clean = (raw, script, max) => {
        const v = String(raw || "");
        return script ? v.slice(0, max) : v.toUpperCase().replace(/[^A-Z0-9 .'-]/g, "").slice(0, max);
      };

      const HANSIEF_EM = {" ":0.19,"'":0.2,"-":0.35,".":0.23,"0":0.53,"1":0.53,"2":0.53,"3":0.53,"4":0.53,"5":0.53,"6":0.53,"7":0.53,"8":0.53,"9":0.53,A:0.54,B:0.59,C:0.51,D:0.57,E:0.44,F:0.43,G:0.57,H:0.62,I:0.26,J:0.52,K:0.52,L:0.42,M:0.75,N:0.6,O:0.57,P:0.57,Q:0.58,R:0.57,S:0.52,T:0.46,U:0.61,V:0.57,W:0.76,X:0.55,Y:0.52,Z:0.49};
      const KITTEN_EM = {" ":0.27,"'":0.2,"-":0.42,".":0.3,A:0.79,B:0.67,C:0.69,D:0.68,E:0.6,F:0.84,G:0.76,H:0.84,I:0.29,J:0.32,K:0.69,L:0.6,M:0.93,N:0.72,O:0.85,P:0.65,Q:0.84,R:0.68,S:0.63,T:0.54,U:0.7,V:0.7,W:1,X:0.67,Y:0.67,Z:0.68,a:0.5,b:0.48,c:0.39,d:0.47,e:0.42,f:0.38,g:0.5,h:0.48,i:0.25,j:0.25,k:0.49,l:0.29,m:0.7,n:0.5,o:0.46,p:0.46,q:0.48,r:0.45,s:0.44,t:0.31,u:0.51,v:0.48,w:0.71,x:0.5,y:0.52,z:0.44};
      const charEm = (ch, script) => {
        const table = script ? KITTEN_EM : HANSIEF_EM;
        const key = script ? ch : String(ch).toUpperCase();
        if (table[key] != null) return table[key];
        return script ? 0.52 : 0.54;
      };
      const textEm = (text, script) => {
        if (!text) return 0;
        return [...text].reduce((sum, ch) => sum + charEm(ch, script), 0);
      };

      const paintLetters = () => {
        const font = currentFont();
        const script = font === "kitten";
        const family = script ? "'Kitten Bold', cursive" : "Hansief, sans-serif";
        const top = clean(topInput && topInput.value, script, 14);
        const bot = clean(botInput && botInput.value, script, 14);
        const feltBtn = $("[data-felt-swatches] .is-on", card);
        const color = (feltBtn && feltBtn.getAttribute("data-hex")) || "#f6ece2";
        const longest = Math.max(textEm(top, script), textEm(bot, script), 1);
        const size = Math.min(68, 265 / longest);
        const chars = [...top];
        const n = chars.length;
        const widths = chars.map((ch) => charEm(ch, script) * size);
        const total = widths.reduce((s, w) => s + w, 0) || size;
        const half = total / 2;
        const safe = Math.max(half, 4);
        const dip = safe * (script ? 0.36 : 0.43);
        const peakY = script ? 92 : 84;
        const r = (safe * safe + dip * dip) / (2 * dip);
        const cy = peakY + r;
        const arcY = peakY + dip;
        const botY = top ? arcY + Math.max(size * 0.54, 30) : 120 + size * 0.15;
        const svgEl = letters && letters.querySelector("svg");
        if (svgEl) svgEl.setAttribute("viewBox", "0 0 400 240");
        if (arcGroup) {
          while (arcGroup.firstChild) arcGroup.removeChild(arcGroup.firstChild);
          if (script && top) {
            const pathId = "gcs-arc-" + Math.random().toString(36).slice(2, 9);
            const path = document.createElementNS(svgNS, "path");
            path.setAttribute("id", pathId);
            path.setAttribute("fill", "none");
            path.setAttribute("d", "M " + (200 - half) + " " + arcY + " A " + r + " " + r + " 0 0 1 " + (200 + half) + " " + arcY);
            const text = document.createElementNS(svgNS, "text");
            text.setAttribute("fill", color);
            text.setAttribute("font-size", String(size));
            text.setAttribute("font-family", family);
            text.setAttribute("letter-spacing", "0");
            text.setAttribute("spacing", "exact");
            const tp = document.createElementNS(svgNS, "textPath");
            tp.setAttribute("href", "#" + pathId);
            tp.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + pathId);
            tp.setAttribute("startOffset", "50%");
            tp.setAttribute("text-anchor", "middle");
            tp.textContent = top;
            text.appendChild(tp);
            arcGroup.appendChild(path);
            arcGroup.appendChild(text);
          } else {
            let cursor = -half;
            chars.forEach((ch, i) => {
              const w = widths[i];
              const xLinear = 200 + cursor + w / 2;
              cursor += w;
              let px = xLinear, py = arcY, angle = 0;
              if (n > 1) {
                const theta = Math.asin(Math.max(-1, Math.min(1, (xLinear - 200) / r)));
                px = 200 + r * Math.sin(theta);
                py = cy - r * Math.cos(theta);
                angle = theta * 180 / Math.PI;
              }
              const el = document.createElementNS(svgNS, "text");
              el.setAttribute("x", String(px));
              el.setAttribute("y", String(py));
              el.setAttribute("text-anchor", "middle");
              el.setAttribute("dominant-baseline", "alphabetic");
              el.setAttribute("transform", "rotate(" + angle + " " + px + " " + py + ")");
              el.setAttribute("fill", color);
              el.setAttribute("font-size", String(size));
              el.setAttribute("font-family", family);
              el.textContent = ch;
              arcGroup.appendChild(el);
            });
          }
        }
        if (botText) {
          botText.setAttribute("fill", color);
          botText.setAttribute("font-size", String(size));
          botText.setAttribute("letter-spacing", "0");
          botText.setAttribute("font-family", family);
          botText.setAttribute("y", String(botY));
          botText.textContent = bot;
          botText.style.display = bot ? "" : "none";
        }
      };


      const applyFont = (id) => {
        card.setAttribute("data-font", id);
        if (letters) {
          letters.classList.toggle("is-hansief", id === "hansief");
          letters.classList.toggle("is-kitten", id === "kitten");
        }
        [topInput, botInput].forEach((input) => {
          if (!input) return;
          input.classList.toggle("is-hansief", id === "hansief");
          input.classList.toggle("is-kitten", id === "kitten");
        });
        $$("[data-font-btns] button", card).forEach((b) => {
          b.classList.toggle("is-on", b.getAttribute("data-font") === id);
        });
        paintLetters();
      };

      const applyColor = (style, colorId) => {
        const group = $('[data-colors="' + style + '"]', card);
        if (!group) return;
        const btn = $('[data-color="' + colorId + '"]', group) || $("[data-color]", group);
        $$("[data-color]", group).forEach((b) => b.classList.remove("is-on"));
        if (btn) btn.classList.add("is-on");
        const id = btn ? btn.getAttribute("data-color") : colorId;
        const src = crewAssets[style] && crewAssets[style][id];
        if (img && src) img.src = src;
        if (colorName) colorName.textContent = (btn && btn.getAttribute("title")) || "";
      };

      const applyStyle = (style) => {
        card.setAttribute("data-style", style);
        if (letters) letters.classList.toggle("is-hanging", style === "pigment");
        $$("[data-style-btns] button", card).forEach((b) => {
          b.classList.toggle("is-on", b.getAttribute("data-style") === style);
        });
        $$("[data-colors]", card).forEach((el) => {
          const on = el.getAttribute("data-colors") === style;
          el.hidden = !on;
          el.classList.toggle("is-off", !on);
        });
        const lineLabel = $("[data-line-label]", card);
        if (lineLabel) lineLabel.textContent = styleLabels[style] || "";
        const group = $('[data-colors="' + style + '"]', card);
        const on = group && ($(".is-on", group) || $("[data-color]", group));
        applyColor(style, on ? on.getAttribute("data-color") : "");
      };

      topInput && topInput.addEventListener("input", paintLetters);
      botInput && botInput.addEventListener("input", paintLetters);
      $$("[data-style-btns] button", card).forEach((btn) => {
        btn.addEventListener("click", () => applyStyle(btn.getAttribute("data-style")));
      });
      $$("[data-colors] button", card).forEach((btn) => {
        btn.addEventListener("click", () => applyColor(currentStyle(), btn.getAttribute("data-color")));
      });
      $$("[data-font-btns] button", card).forEach((btn) => {
        btn.addEventListener("click", () => applyFont(btn.getAttribute("data-font")));
      });
      $$("[data-felt-swatches] button", card).forEach((btn) => {
        btn.addEventListener("click", () => {
          $$("[data-felt-swatches] button", card).forEach((b) => b.classList.remove("is-on"));
          btn.classList.add("is-on");
          paintLetters();
        });
      });
      applyStyle(currentStyle());
      applyFont(currentFont());
    };
    const relabelLines = () => {
      const cards = $$(".gcs-crew-card", list);
      cards.forEach((row, i) => {
        const label = $("[data-line-label]", row);
        if (label) label.textContent = styleLabels[row.getAttribute("data-style") || "pigment"] || "Pigment Dyed Crew";
        const rm = $("[data-remove-line]", row);
        if (rm) {
          rm.hidden = cards.length < 2;
          rm.onclick = () => { row.remove(); relabelLines(); };
        }
      });
    };
    const addLine = () => {
      if (!list || !tpl) return;
      const node = tpl.content.cloneNode(true);
      const card = node.querySelector(".gcs-crew-card");
      list.appendChild(node);
      if (card) bindCard(card);
      relabelLines();
    };
    $("[data-add-line]") && $("[data-add-line]").addEventListener("click", addLine);
    addLine();

    const storeField = $("[data-store-field]");
    const hitNote = $("[data-store-hit]");
    const savedNote = $("[data-store-saved]");
    const hintNote = $("[data-store-hint]");
    const valBook = (name) => (book && book.querySelector('[name="' + name + '"]') || {}).value || "";
    const fillAccount = (loose) => {
      if (!storeField || !book) return;
      const n = norm(storeField.value);
      if (!n) return;
      const hit = accounts.find((a) => norm(a.store) === n) || (loose && n.length > 4 ? accounts.find((a) => norm(a.store).indexOf(n) === 0) : null);
      if (!hit) { if (hitNote) hitNote.hidden = true; return; }
      const set = (name, v) => { const el = book.querySelector('[name="' + name + '"]'); if (el && v) el.value = v; };
      set("contact[name]", hit.name);
      set("contact[email]", hit.email);
      set("contact[phone]", hit.phone);
      set("contact[ship_street]", hit.ship);
      set("contact[ship_city]", hit.city);
      set("contact[ship_state]", hit.region);
      set("contact[ship_zip]", hit.zip);
      set("contact[pay_by]", hit.payBy);
      if (hitNote) hitNote.hidden = false;
      if (savedNote) savedNote.hidden = true;
      if (hintNote) hintNote.hidden = true;
    };
    storeField && storeField.addEventListener("change", () => fillAccount(true));
    storeField && storeField.addEventListener("blur", () => fillAccount(true));
    storeField && storeField.addEventListener("input", () => fillAccount(false));
    book && book.addEventListener("input", () => {
      persistAccount({
        store: valBook("contact[business]"),
        name: valBook("contact[name]"),
        email: valBook("contact[email]"),
        phone: valBook("contact[phone]"),
        ship: valBook("contact[ship_street]"),
        city: valBook("contact[ship_city]"),
        region: valBook("contact[ship_state]"),
        zip: valBook("contact[ship_zip]"),
        payBy: valBook("contact[pay_by]"),
      });
      if (valBook("contact[business]") && valBook("contact[email]")) {
        if (savedNote) savedNote.hidden = false;
        if (hintNote) hintNote.hidden = true;
      }
    });

    book && book.addEventListener("submit", () => {
      const body = $("[data-order-body]", book);
      if (!body) return;
      const crewLines = $$(".gcs-crew-card", list).map((row, i) => {
        const top = (($("[data-f='lettering-top']", row) || {}).value || "").trim();
        const bot = (($("[data-f='lettering-bottom']", row) || {}).value || "").trim();
        const lettering = [top, bot].filter(Boolean).join(" / ");
        const styleId = row.getAttribute("data-style") || "pigment";
        const group = $('[data-colors="' + styleId + '"]', row);
        const colorBtn = group && $(".is-on", group);
        const color = (colorBtn && colorBtn.getAttribute("title")) || "";
        const fontId = row.getAttribute("data-font") || "hansief";
        const feltBtn = $("[data-felt-swatches] .is-on", row);
        const felt = (feltBtn && feltBtn.getAttribute("data-felt")) || "";
        const sizes = $$("[data-sz]", row).map((inp) => inp.getAttribute("data-sz") + ":" + (inp.value || "0")).join(" ");
        return (i + 1) + ". " + lettering + " — " + (styleLabels[styleId] || styleId) + " / " + color + " / " + (fontLabels[fontId] || fontId) + " / felt " + felt + " — " + sizes;
      });
      body.value = [
        "WHOLESALE ORDER",
        "Business: " + valBook("contact[business]"),
        "Name: " + valBook("contact[name]"),
        "Email: " + valBook("contact[email]"),
        "Phone: " + valBook("contact[phone]"),
        "Ship: " + valBook("contact[ship_street]") + ", " + valBook("contact[ship_city]") + ", " + valBook("contact[ship_state]") + " " + valBook("contact[ship_zip]"),
        "In-hand: " + valBook("contact[in_hand]"),
        "Invoice how: " + valBook("contact[pay_by]"),
        "",
        "CREWS",
        crewLines.join("\n"),
        "",
        "Notes: " + valBook("contact[notes]"),
      ].join("\n");
    });
  }
})();
